'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Lodash


var _glamor = require('glamor');

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _last = require('lodash/last');

var _last2 = _interopRequireDefault(_last);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _times = require('lodash/times');

var _times2 = _interopRequireDefault(_times);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _simpleLinearScale = require('simple-linear-scale');

var _simpleLinearScale2 = _interopRequireDefault(_simpleLinearScale);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Presets
// ------------------------------------------------------------------------------
var range = [15, 25]; // From 15px to 25px
var domain = [400, 1600]; // From 400px to 1600px
var step = 200;
var low = (0, _first2.default)(domain);
var high = (0, _last2.default)(domain);
var bounds = (high - low) / step;
var paragraphSpacingFactor = 1;
var indentParagraphs = false;
var emSize = 16;

// ------------------------------------------------------------------------------
// ------------------------------------------------------------- Type Declaration
// ------------------------------------------------------------------------------
/** generateParagraphType
 *
 * Generates type definitions for paragraphs
 *
 */
var generateParagraphType = function generateParagraphType(kitId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var kit = _.typeSets[kitId];

  // EM Size
  var definedEmSize = emSize;
  if (!(0, _isUndefined2.default)(options.emSize)) {
    definedEmSize = options.emSize;
  } else if (!(0, _isUndefined2.default)(kit.paragraphs.emSize)) {
    definedEmSize = kit.paragraphs.emSize;
  }

  // Paragraph font size ranges
  var definedRange = range;
  if (!(0, _isUndefined2.default)(options.range)) {
    definedRange = options.range;
  } else if (!(0, _isUndefined2.default)(kit.paragraphs.range)) {
    definedRange = kit.paragraphs.range;
  }
  var definedScale = (0, _simpleLinearScale2.default)(domain, definedRange, true);
  var lowInEm = (0, _first2.default)(definedRange) / definedEmSize;

  // Paragraph spacing
  var definedParagraphSpacingFactor = paragraphSpacingFactor;
  if (!(0, _isUndefined2.default)(options.paragraphSpacingFactor)) {
    definedParagraphSpacingFactor = options.paragraphSpacingFactor;
  } else if (!(0, _isUndefined2.default)(kit.paragraphs.paragraphSpacingFactor)) {
    definedRange = kit.paragraphs.paragraphSpacingFactor;
  }
  definedParagraphSpacingFactor = 2 - definedParagraphSpacingFactor;

  // Paragraph indent
  var definedIndentParagraphs = indentParagraphs;
  if (!(0, _isUndefined2.default)(options.indentParagraphs)) {
    definedIndentParagraphs = options.indentParagraphs;
  } else if (!(0, _isUndefined2.default)(kit.paragraphs.indentParagraphs)) {
    definedIndentParagraphs = kit.paragraphs.indentParagraphs;
  }

  var xHeight = kit.metadata.paragraphs.annotation.xHeight;

  var styleObject = {};
  (0, _times2.default)(bounds + 1, function (boundX) {
    var bound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : boundX;

    var at = bound * step + low;
    var fontSize = definedScale(at + step / 2);
    var inEm = fontSize / definedEmSize;
    (0, _set2.default)(styleObject, '@media(min-width: ' + at + 'px)', {
      '& p, ul:not(.mask-p) > li, ol:not(.mask-p) > li, .mask-p': {
        fontSize: inEm + 'rem'
      },
      '& .margin-p': {
        fontSize: fontSize + 'px'
      },
      '& p, .mask-p, .margin-p': {
        marginBottom: inEm * 2.4 * definedParagraphSpacingFactor + 'rem',
        marginTop: 0
      },
      '& p + p, p + .mask-p, p + .margin-p': {
        marginTop: '-' + inEm * 1.8 * definedParagraphSpacingFactor + 'rem',
        textIndent: definedIndentParagraphs === true ? 10 : 0
      },
      '& .mask-p + p, .mask-p + .mask-p, .mask-p + .margin-p': {
        marginTop: '-' + inEm * 1.8 * definedParagraphSpacingFactor + 'rem',
        textIndent: definedIndentParagraphs === true ? 10 : 0
      },
      '& .margin-p + p, .margin-p + .mask-p, .margin-p + .margin-p': {
        marginTop: '-' + inEm * 1.8 * definedParagraphSpacingFactor + 'rem',
        textIndent: definedIndentParagraphs === true ? 10 : 0
      },
      '& ul > li, ol > li': {
        marginBottom: inEm * 0.35 * definedParagraphSpacingFactor + 'rem'
      },
      '& ul:not(.mask-p) > li:last-child, ol:not(.mask-p) > li:last-child': {
        marginBottom: inEm * 1.05 * definedParagraphSpacingFactor + 'rem'
      },
      '& ul:not(.margin-p) > li:last-child, ol:not(.margin-p) > li:last-child': {
        marginBottom: inEm * 1.05 * definedParagraphSpacingFactor + 'rem'
      }
    });
  });

  var style = (0, _glamor.css)(_extends({
    '& p, ul:not(.mask-p) > li, ol:not(.mask-p) > li, .mask-p': {
      fontFamily: kit.paragraphs.fontFamily,
      fontWeight: kit.paragraphs.lowerFontWeight,
      fontSize: lowInEm + 'rem'
    },
    '& .margin-p': {
      fontSize: (0, _first2.default)(definedRange) + 'px'
    },
    '& p, ul:not(.mask-p) > li, ol:not(.mask-p) > li, .mask-p, .margin-p': {
      lineHeight: xHeight === 'high' ? lowInEm * 1.75 + 'rem' : 'normal'
    },
    '& p, .mask-p, .margin-p': {
      marginBottom: lowInEm * 2.4 + 'rem',
      marginTop: 0
    },
    '& p + p, p + .mask-p, p + .margin-p': {
      marginTop: '-' + lowInEm * 1.8 + 'rem'
    },
    '& .mask-p + p, .mask-p + .mask-p, .mask-p + .margin-p': {
      marginTop: '-' + lowInEm * 1.8 + 'rem'
    },
    '& .margin-p + p, .margin-p + .mask-p, .margin-p + .margin-p': {
      marginTop: '-' + lowInEm * 1.8 + 'rem'
    },
    '& ul > li, ol > li': {
      marginBottom: lowInEm * 0.35 + 'rem'
    },
    '& ul:not(.mask-p) > li:last-child, ol:not(.mask-p) > li:last-child': {
      marginBottom: lowInEm * 1.05 + 'rem'
    },
    '& ul:not(.margin-p) > li:last-child, ol:not(.margin-p) > li:last-child': {
      marginBottom: lowInEm * 1.05 + 'rem'
    }
  }, styleObject));

  var className = style.toString();

  return className;
};

// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Exports
// ------------------------------------------------------------------------------
exports.default = generateParagraphType;
module.exports = exports['default'];